module.exports = __webpack_public_path__ + "static/media/InsB.074c507c.png";